import {
  BusinessTypeResponse,
  BusinessTypeUpdatePayload,
  CreateAmazonProfilePayload,
  OnboardingConditionUpdate,
  OnboardingStatus,
} from '@/types/onboarding';
import { apiClient } from '../client';
import { OverallOnboardingDto } from '@/context/OnboardingContext.tsx';
export const onboardingService = {
  checkStatus: async (userId: number): Promise<OnboardingStatus> => {
    const { data } = await apiClient.post('/onboarding/check-status', {
      userId,
    });
    return data;
  },

  checkAmazonProfile: async (userId: number): Promise<OnboardingStatus> => {
    const { data } = await apiClient.post('/onboarding/check-amazon-profile', {
      userId,
    });
    return data;
  },

  updateCondition: async (
    payload: OnboardingConditionUpdate
  ): Promise<OnboardingStatus> => {
    const { data } = await apiClient.post(
      '/onboarding/update-condition',
      payload
    );
    return data;
  },

  resetOnboarding: async (userId: string): Promise<{ success: boolean }> => {
    const { data } = await apiClient.post('/onboarding/reset', { userId });
    return data;
  },

  createAmazonProfile: async (
    payload: CreateAmazonProfilePayload
  ): Promise<any> => {
    const { data } = await apiClient.post('/amazon-profile', payload);
    return data;
  },

  updateBusinessType: async (
    payload: BusinessTypeUpdatePayload
  ): Promise<BusinessTypeResponse> => {
    const { data } = await apiClient.post(
      '/onboarding/update-business-type',
      payload
    );
    return data;
  },

  getBusinessType: async (
    userId: number
  ): Promise<BusinessTypeResponse | null> => {
    try {
      const { data } = await apiClient.get(
        `/onboarding/business-type/${userId}`
      );
      return data;
    } catch (error) {
      console.error('Error fetching business type:', error);
      return null;
    }
  },

  onBoardingOverall: async (data: OverallOnboardingDto) => {
    const { data: response } = await apiClient.post(
      '/onboarding/onboarding-complete',
      data
    );
    return response;
  },
};
